// ----------------------------------------------------------------------

export default function Stepper(theme) {
  return {
    MuiStepConnector: {
      styleOverrides: {
        line: {
          borderColor: theme.palette.divider,
        },
      },
    },
    MuiStepContent: {
      styleOverrides: {
        root: {
          borderColor: theme.palette.divider,
        },
      },
    },
    MuiStepLabel: {
      styleOverrides: {
        iconContainer: {
          '& .MuiStepIcon-root:not(.Mui-active)': {
            fill: theme.palette.text.disabled,
          },
          '& .MuiStepIcon-text': {
            fill: theme.palette.common.white,
          },
        },
      },
    },
  };
}
